import { render } from "./YouTubeEmbed.vue?vue&type=template&id=665f2a1d"
import script from "./YouTubeEmbed.vue?vue&type=script&lang=js"
export * from "./YouTubeEmbed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__